import { Expose } from 'class-transformer'

export class SalesAnalyticsDataTableType {
  @Expose() bookTitle: string

  @Expose() characterName: string

  @Expose() total: number
}
